export default "__VITE_ASSET__B$J7AcTp__"